module.exports = __webpack_public_path__ + "static/media/click.17eda873.svg";